<template>
  <div>
    <b-card
      align="left"
      class="view-booking side-card colored"
      v-if="booking"
    >
      <b-row>
        <b-col><h4>{{ booking.getName }}</h4></b-col>
        <b-col
          class="text-right"
          v-if="booking !== null && booking.getOpened && !booking.getBroadcasted"
        >
          <span class="edit-booking" v-b-modal.update-technician-booking-modal>
            <img :src="require('@/assets/icons/edit_card.svg')">
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" lg="3">
          <TitleValue title="ID del booking" :value="booking.getCode"/>
        </b-col>
        <b-col cols="6" lg="3">
          <TitleValue title="Creado por" :value="booking.getCreatedBy"/>
        </b-col>
        <div class="d-block-sm w-100" />
        <b-col cols="6" lg="3">
          <TitleValue title="Fecha de creación" :value="getDate(booking.getCreatedAt)"/>
        </b-col>
        <b-col cols="6" lg="3">
          <TitleValue title="Estado" :value="getBookingStatus(booking)"/>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      align="left"
      class="view-booking side-card colored"
      v-if="booking"
    >
      <b-row>
        <b-col><h4>Detalles del evento</h4></b-col>
        <b-col
          class="text-right"
          v-if="booking !== null && booking.getOpened && !booking.getBroadcasted"
        >
          <span class="edit-booking" v-b-modal.update-technician-booking-modal>
            <img :src="require('@/assets/icons/edit_card.svg')">
          </span>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6" lg="3">
          <TitleValue title="Fecha del evento" :value="getEventDates(booking)"/>
        </b-col>
        <b-col cols="6" lg="3">
          <TitleValue title="Hora del evento" :value="getEventHours(booking)"/>
        </b-col>
        <b-col cols="6" lg="3">
          <TitleValue title="Lugar del evento" :value="getLocation(booking.getLocation)"/>
        </b-col>
        <b-col cols="6" lg="3">
          <TitleValue title="Tipo de evento" :value="booking.getEventType.name"/>
        </b-col>
      </b-row>
      <b-row class="start" v-if="booking.getDocExtra || booking.getDocs.length > 0">
        <b-col>
          Documentos
        </b-col>
      </b-row>
      <b-row class="end">
        <b-col>
          <SkillBadge
            v-for="doc in booking.getDocs"
            :key="doc.id"
            :name="doc.name"
          />
          <SkillBadge
            :name="booking.getDocExtra"
            v-if="booking.getDocExtra"
          />
        </b-col>
      </b-row>
    </b-card>
    <ListTechnicianPosition
      @onViewDetailPosition="$emit('onViewDetailPosition')"
    />
    <b-row class="button-wrapper">
      <b-col>
        <b-button
          v-if="canBePublished"
          v-b-modal.broadcast-booking
          class="float-right broadcast-booking"
          variant="primary">
            Publicar booking
        </b-button>
        <b-button
          v-if="booking !== null && booking.getBroadcasted && booking.getOpened"
          @click="$bvModal.show('close-booking')"
          class="float-right broadcast-booking"
          variant="primary">
            Cerrar Booking
        </b-button>
      </b-col>
    </b-row>
    <UpdateTechnicianBookingModal />
    <BroadcastTechnicianBookingNativeModal
      @onBroadcastBooking="onBroadcastBooking"
    />
    <CloseTechnicianBookingModal
      @onCloseBooking="onCloseBooking"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TitleValue from '@/components/Bookings/TitleValue.vue'
import SkillBadge from '@/components/SkillBadge/SkillBadge.vue'
import ListTechnicianPosition from '@/components/Business/Project/TechnicianPosition/List/ListTechnicianPosition.vue'
import UpdateTechnicianBookingModal from '@/components/Business/Project/TechnicianBooking/Update/UpdateTechnicianBookingModal.vue'
import BroadcastTechnicianBookingNativeModal from '@/components/Business/Project/TechnicianBooking/BroadcastBooking/Native/BroadcastTechnicianBookingNativeModal.vue'
import CloseTechnicianBookingModal from '@/components/Business/Project/TechnicianBooking/CloseBooking/CloseTechnicianBookingModal.vue'

export default {
  name: 'DetailTechnicianBooking',
  components: {
    TitleValue,
    SkillBadge,
    ListTechnicianPosition,
    UpdateTechnicianBookingModal,
    BroadcastTechnicianBookingNativeModal,
    CloseTechnicianBookingModal
  },
  computed: {
    ...mapGetters({ booking: 'technicianBooking/current' }),
    canBePublished () {
      return this.booking !== null &&
        this.booking.getOpened &&
        !this.booking.getBroadcasted &&
        this.booking.positions.length > 0
    }
  },
  methods: {
    ...mapActions('technicianBooking', { updateBooking: 'update' }),
    getDate (date) {
      return this.lpad(date.getDate()) + '/' +
        this.lpad((date.getMonth() + 1)) + '/' +
        date.getFullYear()
    },
    lpad (data) {
      return String(data).padStart(2, '0')
    },
    getBookingStatus (booking) {
      if (booking.getOpened) {
        return 'Abierto'
      }
      return 'Cerrado'
    },
    getEventDates (booking) {
      const start = booking.getEventStartAt
      const end = booking.getEventEndAt
      if (
        start.getMonth() === end.getMonth() &&
        start.getFullYear() === end.getFullYear()
      ) {
        return this.getShortDates(start, end)
      }
      return this.getLongDates(start, end)
    },
    getShortDates (start, end) {
      return this.lpad(start.getDate()) + ' - ' +
        this.lpad(end.getDate()) + ' de ' +
        this.getMonth(start.getMonth()) + ' ' +
        start.getFullYear()
    },
    getLongDates (start, end) {
      return this.lpad(start.getDate()) + '/' +
        this.lpad(start.getMonth() + 1) + '/' +
        start.getFullYear() + ' al ' +
        this.lpad(end.getDate()) + '/' +
        this.lpad(end.getMonth() + 1) + '/' +
        end.getFullYear()
    },
    getMonth (jsMonth) {
      return [
        'enero',
        'febrero',
        'marzo',
        'abil',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
      ][jsMonth]
    },
    getEventHours (booking) {
      const start = booking.getEventStartAt
      const end = booking.getEventEndAt
      return this.lpad(start.getHours()) + ':' + this.lpad(start.getMinutes()) +
        ' - ' +
        this.lpad(end.getHours()) + ':' + this.lpad(end.getMinutes())
    },
    getLocation (location) {
      return location.name + ' (' + location.administrative + ')'
    },
    onBroadcastBooking () {
      const payload = {
        projectId: this.$route.params.id,
        data: this.booking
      }
      this.$store.dispatch('technicianBooking/broadcastBooking', payload)
        .then(() => {
          this.$bvModal.hide('broadcast-booking')
          this.$store.dispatch('showConfirmationModal')
        })
        .catch(error => {
          this.$bvModal.hide('broadcast-booking')
          console.log(error)
        })
    },
    onCloseBooking () {
      const editableBooking = { ...this.booking }
      editableBooking.opened = false
      delete editableBooking.createdAt
      delete editableBooking.broadcasted
      const payload = {
        projectId: this.$route.params.id,
        data: editableBooking
      }
      this.updateBooking(payload)
        .then(() => {
          this.$bvModal.hide('close-booking')
          this.$store.dispatch('showConfirmationModal')
        })
        .catch(error => {
          this.$bvModal.hide('close-booking')
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import "detailTechnicianBooking";
</style>
